import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { StatusValueDate } from '../../../../@core/data/statusValue';

@Component({
  selector: 'ngx-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
})
export class DateInputComponent implements OnInit, AfterViewInit {
  date: Date = new Date();
  showErrorMessage: boolean = false;
  private delayTime: number = 1000;
  private validtionDelay;
  @Input() dateValue: string;
  @Input() require: boolean = false;
  @Input() label: string = '';
  @Input() size = 'small';
  // @Input() minDate = null;
  // @Input() maxDate = null; // should be yyyy-MM-dd
  @Output() dateInputStatus = new EventEmitter<StatusValueDate>();
  @ViewChild('child', { static: false }) feild: ElementRef;
  constructor() {}

  ngOnInit() {
    this.date = new Date(this.dateValue);
  }
  startCountingToShowValidation() {
    if (!this.feild.nativeElement.validity.valid) {
      this.cancelValidation();
      this.Validate();
    } else this.showErrorMessage = false;

    this.dateInputStatus.emit({
      status: this.feild.nativeElement.validity.valid,
      value: this.date,
    });
  }

  Validate() {
    this.validtionDelay = setTimeout(() => {
      this.showErrorMessage = true;
    }, this.delayTime);
  }

  cancelValidation() {
    clearTimeout(this.validtionDelay);
  }
  ngAfterViewInit(): void {
    // this.feild.nativeElement.validity.valid
    setTimeout(() => {
      this.dateInputStatus.emit({
        status: this.feild.nativeElement.validity.valid,
        value: this.date,
      });
    });
  }
}
